/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateScoreLogicRequest } from '../models/CreateScoreLogicRequest';
import type { CreateScoreLogicResponse } from '../models/CreateScoreLogicResponse';
import type { ScoreLogic } from '../models/ScoreLogic';
import type { ScoreLogicResponse } from '../models/ScoreLogicResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ScoreLogicService {

    /**
     * Create a new score logic entry.
     * @param organizationId The ID of the organization.
     * @param requestBody The request to create a score logic entry.
     * @returns CreateScoreLogicResponse OK
     * @throws ApiError
     */
    public static createScoreLogic(
        organizationId: string,
        requestBody?: CreateScoreLogicRequest,
    ): CancelablePromise<CreateScoreLogicResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/scorelogic/{organizationId}/create',
            path: {
                'organizationId': organizationId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Delete a specific score logic entry.
     * @param organizationId The ID of the organization.
     * @param scorelogicId The ID of the score logic entry to delete.
     * @returns void
     * @throws ApiError
     */
    public static deleteScoreLogic(
        organizationId: string,
        scorelogicId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/scorelogic/{organizationId}/{scorelogicId}',
            path: {
                'organizationId': organizationId,
                'scorelogicId': scorelogicId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * Get a specific score logic entry.
     * @param organizationId The ID of the organization.
     * @param scorelogicId The ID of the score logic entry.
     * @returns ScoreLogic OK
     * @throws ApiError
     */
    public static getScoreLogicById(
        organizationId: string,
        scorelogicId: string,
    ): CancelablePromise<ScoreLogic> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/scorelogic/{organizationId}/{scorelogicId}',
            path: {
                'organizationId': organizationId,
                'scorelogicId': scorelogicId,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * @param organizationId
     * @returns ScoreLogicResponse OK
     * @throws ApiError
     */
    public static getScoreLogics(
        organizationId: string,
    ): CancelablePromise<ScoreLogicResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/scorelogic/{organizationId}',
            path: {
                'organizationId': organizationId,
            },
        });
    }

}
